module.exports = __webpack_public_path__ + "img/question-edit.91545100.svg";